var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdventure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 20 20",
    height: "36px",
    viewBox: "0 0 20 20",
    width: "36px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 20,
    width: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5,3.25C15.5,4.22,14.72,5,13.75,5S12,4.22,12,3.25s0.78-1.75,1.75-1.75S15.5,2.28,15.5,3.25z M15,16.5 c-1.52,1.33-3.48,1.33-5,0c-1.52,1.33-3.47,1.33-5,0c-0.76,0.67-1.63,1-2.5,1H2V19h0.5c0.86,0,1.71-0.2,2.5-0.6 c1.57,0.8,3.42,0.8,5,0c1.57,0.8,3.42,0.8,5,0c0.79,0.4,1.64,0.6,2.5,0.6H18l0-1.5h-0.5C16.63,17.5,15.76,17.17,15,16.5z M11.9,7.2 L10,8.48L13,11v3.09c0.5,0.35,0.98,0.71,1.41,1.07c-0.54,0.5-1.2,0.84-1.91,0.84c-1,0-1.89-0.66-2.5-1.5C9.39,15.34,8.5,16,7.5,16 c-0.19,0-0.37-0.02-0.55-0.07C4.71,14.38,3,12.66,3,11.52c0-0.45,0.28-1.02,1.47-1.02c0.68,0,1.56,0.19,2.53,0.51L6.53,8.28 c-0.1-0.57,0.13-1.16,0.63-1.5l1.72-1.16L7.54,5.38l-2.3,1.56L4.4,5.7l2.8-1.9l4.22,0.69c0.36,0.06,0.69,0.23,0.91,0.51l1.38,2.1 c0.64,0.85,1.66,1.4,2.8,1.4V10c-1.64,0-3.09-0.79-4-2L11.9,7.2z M8.4,9.15l0.35,2.55c0.86,0.37,2.18,1.05,2.74,1.42V11.7L8.4,9.15z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdventure);
export default __webpack_public_path__ + "static/media/adventure.32e14d23.svg";
export { ForwardRef as ReactComponent };